// extracted by mini-css-extract-plugin
module.exports = {"EFFigure":"EFFigure_EFFigure__no5pM"};